exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RegisterForm-displayGridDate-3jXcU {\r\n    display: grid;\r\n    grid-template-columns: 32% 36% 32%;\r\n}\r\n\r\n.RegisterForm-datePadding-3uW4m {\r\n    padding: 0px 8px;\r\n}\r\n\r\n.RegisterForm-checkBoxGrid-hzfz- {\r\n    display: grid;\r\n    grid-template-columns: 24px auto;\r\n}\r\n\r\n.RegisterForm-checkBoxText-3uSks {\r\n    padding-left: 7px;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n    .RegisterForm-displayGridDate-3jXcU {\r\n        grid-template-columns: 100%;\r\n    }\r\n\r\n    .RegisterForm-datePadding-3uW4m {\r\n        padding: 0px;\r\n    }\r\n}", ""]);

// exports
exports.locals = {
	"displayGridDate": "RegisterForm-displayGridDate-3jXcU",
	"datePadding": "RegisterForm-datePadding-3uW4m",
	"checkBoxGrid": "RegisterForm-checkBoxGrid-hzfz-",
	"checkBoxText": "RegisterForm-checkBoxText-3uSks"
};